var _linearGradient;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconOptions = function SvgIconOptions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    className: "nav-icon",
    x: "0px",
    y: "0px",
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    style: {
      enableBackground: "new 0 0 35 35"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029041811099592812220000004211754718424723877_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.5,
    y1: 34.4979,
    x2: 17.5,
    y2: 0.5021
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    className: "icon-gradient-bottom"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    className: "icon-gradient-top"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029041811099592812220000004211754718424723877_)"
    },
    d: "M31.5,14.4c-0.4-1.7-1-3.3-2-4.7l1.9-2.4 l-3.8-3.8l-2.4,1.9c-1.4-0.9-3-1.5-4.6-1.9l-0.4-3.1h-5.4l-0.4,3.1c-1.6,0.4-3.2,1-4.6,1.9l-2.5-2L3.6,7.4l2,2.5 c-0.9,1.4-1.5,2.9-1.9,4.5l-3.2,0.4v5.4l3.2,0.4c0.4,1.6,1,3.2,1.9,4.5l-2,2.5l3.8,3.8l2.5-2c1.4,0.9,2.9,1.5,4.6,1.9l0.4,3.1h5.4 l0.3-3.1c1.7-0.4,3.2-1,4.6-1.9l2.4,1.9l3.8-3.8l-1.9-2.4c0.9-1.4,1.6-3,2-4.7l3-0.3v-5.4L31.5,14.4z M17.6,24.1 c-3.6,0-6.6-2.9-6.6-6.6c0-3.6,2.9-6.6,6.6-6.6c3.6,0,6.6,2.9,6.6,6.6C24.1,21.1,21.2,24.1,17.6,24.1z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconOptions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-options.4dc4c75b.svg";
export { ForwardRef as ReactComponent };